import './default_module'
import { redirectAsPost } from 'javascripts/general_scripts'

/* stylesheet */
import 'stylesheets/products/leaderboard.less'

window.redirectAsPost = redirectAsPost;